<template>
	<div id="appbox">
		<div class="top_heard">
				<div class="top_box" v-if="screenWidth>785">
					<div class="logo_box"  @click="gohome()">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					
					<div class="top_search_box" v-if="screenWidth>785" >
						<div class="top_search">
							<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							  <el-option
							    v-for="item in options"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								
								>
							  </el-option>
							</el-select>
							<!-- <i class="el-icon-search"></i> -->
							<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
							<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
						</div>
						  
					</div>
				
				</div>
				<div class="top_tab_box">
					<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
						<template #left>
							<div class="vannav_title" style="color: #217495;font-size: 16px;" >
								线路详情
							</div>
						</template>
						<template #title>
							<div class="vannav_title" style="width: 180px;padding: 20px;">
									<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
							</div>
						</template>
					  <template #right>
						  <van-icon name="ellipsis"  size="20"    />
					  </template>
					</van-nav-bar>
					<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
						<van-picker
						  title=""
						  show-toolbar
						  :columns="vannavlist"
						  confirm-button-text="进入"
						  @confirm="vanlinkgo"
						  @cancel="vannavmenushow"
						  @change="onChange"
						/>
					</van-popup>
					<div class="toptabnav" v-if="screenWidth>785">
							<el-menu
							  :default-active="activeIndex2"
							  class="el-menu-demo"
							  mode="horizontal"
							  @select="handleSelect"
							  router
							  background-color="#FE7C2B"
							  text-color="#FFFFFF"
							  active-text-color="#FFFFFF">
							<el-menu-item index="/Home">首页</el-menu-item>
							<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
							<el-menu-item index="/Courselist" >研学课程</el-menu-item>
							<el-submenu index="/institution">
							    <template slot="title">研学机构</template>
							    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
							    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
								<el-menu-item index="/traveler" >会员单位</el-menu-item> 
							  </el-submenu>
							
							<el-menu-item index="/Campmap" >研学地图</el-menu-item>
							<el-menu-item index="/Activitylist">活动中心</el-menu-item>
							<el-menu-item index="/Linelist" >研学线路</el-menu-item>
							<el-submenu index="/yanxueteam">
							    <template slot="title">研学团队</template>
							    <el-menu-item index="/mentorlist" >研学导师</el-menu-item>
							    <el-menu-item index="/expertlist" >专家团队</el-menu-item>
							  </el-submenu>
							<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
						</el-menu>
					</div>
				</div>
			</div>
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="acttop_box" :style="screenWidth>785?'':'width:100%; flex-direction: column;margin-top:0px;'">
				<div class="acttop_imgs" :style="screenWidth>785?'':'width:100%;aspect-ratio: 375/160;height:auto;padding:0px'">
					<img :src="linedata.icon" :style="screenWidth>785?'width: 100%;height: 160px;':'width:100%;aspect-ratio: 375/160;height:auto;'" alt="" srcset="">
				</div>
				<div class="acttop_msg" :style="screenWidth>785?'':'width:calc(100% - 40px);padding:10px;'">
					<el-descriptions class="margin-top" :title="linedata.title" :column="1"  >
						<el-descriptions-item >
						  <template slot="label">
							行程时长
						  </template>
						  {{linedata.days}}天
						</el-descriptions-item>
						<el-descriptions-item v-if="linedata.periods.length>0" >
						  <template slot="label">
							适用学段
						  </template>
						 <el-tag size="small" v-for="tag in linedata.periods" :key="tag" :color="tag.color" effect="dark" >{{tag.title}}</el-tag>
						</el-descriptions-item>
						<el-descriptions-item >
						  <template slot="label">
							发起单位
						  </template>
						  {{linedata.unit}}
						</el-descriptions-item>
						<el-descriptions-item >
						  <template slot="label">
							浏览总量
						  </template>
						  {{linedata.uv}}
						</el-descriptions-item>
						<el-descriptions-item  v-if="linedata.manager" >
						  <template slot="label">
							负责人
						  </template>
						  {{linedata.manager.truename}}
						</el-descriptions-item>
						<el-descriptions-item v-if="linedata.manager"  >
						  <template slot="label">
							联系方式
						  </template>
						  {{linedata.manager.mobile}}
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</div>
			<div class="line_mainbox" :style="screenWidth>785?'':'width:100%; flex-direction: column;'">
				<div class="line_tabsbox" :style="screenWidth>785?'':'width:100%;'">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="线路详情" name="0">
							<div class="richbox" v-if="linedata.content" v-html="linedata.content">
								
							</div>
						</el-tab-pane>
						<el-tab-pane label="线路课程" name="1">
							<div class="linemain">
								<div class="actmain_item" style="" v-for="item in linedata.routetime" v-if="linedata.routetime" :key="item">
									<div class="actmain_title" >
										<span class="actblock" ></span>{{item[0].title||item[1].title}}
									</div>
									<div class="lessonbox">
										<div class="lessontitle" v-if="item.lesson1&&item.lesson1.length">
											{{item[0].typename}}课程
										</div>
										<div class="lesson_item"  v-for="lesson in item.lesson1" v-if="item.lesson1" :key="lesson" @click="golesson(lesson.id)">
											<div class="lessonimg">
												<img :src="lesson.icon" alt="" srcset="">
												<div class="coures_item_type">
													<span v-for="category in lesson.category" :key="category" :style="'background-color:'+category.color+';'">{{category.title}}</span>
													<span v-for="tag in lesson.periods" :key="tag" :style="'background-color:'+tag.color+';'">{{tag.title}}</span>
												</div>
											</div>
											<div class="lessonmsg">
												<el-descriptions class="lessonmsg_el"  :title="lesson.title" :column="1"  >
													<el-descriptions-item   >
													  <template slot="label">
														作者
													  </template>
													  {{lesson.author}}
													</el-descriptions-item>
													<el-descriptions-item >
													  <template slot="label">
														作者单位
													  </template>
													  {{lesson.company}}
													</el-descriptions-item>
													<el-descriptions-item >
													  <template slot="label">
														课程时长
													  </template>
													  {{lesson.research_class}}课时
													</el-descriptions-item>
								<!-- 					<el-descriptions-item >
													  <template slot="label">
														课程类型
													  </template>
													 <el-tag size="small" v-for="category in lesson.category" :key="category" :color="category.color" effect="dark" >{{category.title}}</el-tag>
													</el-descriptions-item>
													<el-descriptions-item >
													  <template slot="label">
														适用学段
													  </template>
													 <el-tag size="small" v-for="tag in lesson.periods" :key="tag" :color="tag.color" effect="dark" >{{tag.title}}</el-tag>
													</el-descriptions-item> -->
												</el-descriptions>
											</div>
										</div>
										<div class="lessontitle" v-if="item.lesson2&&item.lesson2.length">
											{{item[1].typename}}课程
										</div>
										<div class="lesson_item"  v-for="lesson in item.lesson2" v-if="item.lesson2" :key="lesson" @click="golesson(lesson.id)">
											<div class="lessonimg">
												<img :src="lesson.icon" alt="" srcset="">
												<div class="coures_item_type">
													<span v-for="category in lesson.category" :key="category" :style="'background-color:'+category.color+';'">{{category.title}}</span>
													<span v-for="tag in lesson.periods" :key="tag" :style="'background-color:'+tag.color+';'">{{tag.title}}</span>
												</div>
											</div>
											<div class="lessonmsg">
												<el-descriptions class="lessonmsg_el" :title="lesson.title" :column="1"  >
													<el-descriptions-item   >
													  <template slot="label">
														作者
													  </template>
													  {{lesson.author}}
													</el-descriptions-item>
													<el-descriptions-item >
													  <template slot="label">
														作者单位
													  </template>
													  {{lesson.company}}
													</el-descriptions-item>
													<el-descriptions-item >
													  <template slot="label">
														课程时长
													  </template>
													  {{lesson.research_class}}课时
													</el-descriptions-item>
				<!-- 										<el-descriptions-item >
													  <template slot="label">
														课程类型
													  </template>
													 <el-tag size="small" v-for="category in lesson.category" :key="category" :color="category.color" effect="dark" >{{category.title}}</el-tag>
													</el-descriptions-item>
													<el-descriptions-item >
													  <template slot="label">
														适用学段
													  </template>
													 <el-tag size="small" v-for="tag in lesson.periods" :key="tag" :color="tag.color" effect="dark" >{{tag.title}}</el-tag>
													</el-descriptions-item> -->
												</el-descriptions>
											</div>
										</div>
									</div>
								</div>
				 
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
				<div class="line_reply" :style="screenWidth>785?'border: 0px;':'width:calc(100% - 3px);margin-top:20px;'"> 
					<div class="quick_title">
						评论({{commenttotal}})
					</div>
					<div class="replybox" v-if="screenWidth>785" >
						<div class="reply_rate">
							评分:
							<el-rate
							  v-model="replyrate"
							  allow-half=true
							  show-score
							  text-color="#ff9900"
							  score-template="{value}">
							</el-rate>
						</div>
						<div class="reply_input">
							<el-input
							  type="textarea"
							  :autosize="{ minRows: 2, maxRows: 4}"
							  placeholder="请输入评论内容"
							  v-model="replytext">
							</el-input>
						</div>
						<div class="reply_buttonbox">
							<el-upload
								class="upload-demo"
								action=""
								:accept="acceptmedia" 
								:before-upload="beforeAvatarUpload"
								:http-request="upload"
								multiple
								:limit="maxcount"
								:on-exceed="handleExceed"
								:on-remove="beforeRemove"
								:file-list="fileList">
							  <el-button size="small" icon="el-icon-picture-outline"  type="primary">上传</el-button>
							  <div slot="tip" class="el-upload__tip">上传图片或视频，上传一种后无法传另一种</div>
							</el-upload>
							 <el-button type="success" v-if="!token" @click="reply()">发表评论</el-button>
							 <el-popover
							   placement="top"
							 	v-model="showreplyvisible"
							    trigger="manual">
							   <div class="verify-box">
							   	<slide-verify
							   	  ref="replyRef"
							   	  :l="42"
							   	  :r="10"
							   	  :w="280"
							   	  :h="280"
							   	  :imgs="images"
							   	  slider-text="向右滑动"
							   	  @success="onreplySuccess"
							   	  @fail="onreplyFail"
							   	  @refresh="onreplyRefresh"
							   	  @fulfilled="onRefreshComplete"
							   	  @again="onreplyAgain"
							   	>
							   	</slide-verify>
							   </div>
							   <el-button type="success"  slot="reference" v-if="token" @click="showreplyvisible = true">发表评论</el-button>
							 </el-popover>
						</div>
					</div>
					<div class="commentlistbox" v-if="commentlist.length">
						<div class="commentitem"   v-for="(item, index) in commentlist" :key="item" >
							<div class="comment_icon">
								<img :src="item.user.avatarUrl" alt="" srcset="">
							</div>
							<div class="commentmainbox">
								<div class="comment_rate">
									<el-rate
									  v-model="item.star"
									  disabled
									   allow-half=true
									  show-score
									  text-color="#ff9900"
									  score-template="{value}">
									</el-rate>
								</div>
								<div class="commentmaintext">
									<span style="color:#409EFF;" >{{item.user.nickName+'：'}}</span>
									{{item.content}}
								</div>
								<div class="comment_medium">
									<div class="medium_imgs" v-for="(imgs, index) in item.imgs" :key="imgs">
										<el-image
										  style="width: 100px; height: 100px"
										  :src="imgs" 
										  :preview-src-list="item.imgs">
										</el-image>
										<!-- <img :src="imgs" alt="" srcset=""> -->
									</div>
									<div class="medium_video" v-for="(vdo, index) in item.videos" :key="vdo">
										<video :src="vdo" controls="controls"  style="width: 100%;height: 160px;"></video>
									</div>
								</div>
								<div class="comment_msg">
									<div class="comment_time">
										{{item.create_time}}
									</div>
									<div class="replyreply" style="color:brown;"  v-if="screenWidth>785&&item.uid==userdata.id" @click="deletereply(item.id)">
										删除评价
									</div>
								</div>
								
							</div>
							
						</div>
					</div>
					<div class="comment_more">
						<el-pagination
						  background
						  :page-size="15"
						  :hide-on-single-page="true"
						  @current-change="commentpagechange"
						  layout="total, prev, pager, next"
						  :total="commenttotal">
						</el-pagination>
					</div>
				</div>
			</div>
			
			
		</div>
		<!-- <div class="swim_box" v-if="screenWidth>785" >
			<div class="swim_title">
				小程序查看
			</div>
			<div class="swim_code">
				<img :src="linedata.sun_code" alt="" srcset="">
			</div>
		</div> -->
		<div :class="tops?'navbar':'navbar-top'" v-if="screenWidth>785">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		    
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<!-- footer -->
			<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;padding-top:20px;'" >
				<div class="subtexts" v-if="screenWidth>785" >
					<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
				<div class="subnavbox" v-if="screenWidth<785" >
					<div class="subtext_title">
						关于研学平台
					</div>
					<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
						<div v-for="item in bottomnav" :key="item" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
					</div>
				</div>
				<div class="row" :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'" >
					<!-- <div class="copy-left">
						<p><i class="el-icon-phone-outline"></i>{{pcsetdata.phone}}</p>
						<p><i class="el-icon-message"></i>{{pcsetdata.email}}</p>
						<p style="font-size: 13px;">地址信息：{{pcsetdata.address}}</p>
					</div> -->
					
					<div class="copy-left " :style="screenWidth>785?'':'width:40%;'" >
						<div class="bottom_logo"  v-if="screenWidth>785" >
							<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
						</div>
						
					</div>
					<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'" abort="">
						<div class="bottom_msg">
							{{pcsetdata.foot}}
						</div>
						<div class="bottom_msg">
							<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
						</div>
						<div class="bottom_msg">
							课程适用人群:学生群体
						</div>
					</div>
					
				</div>
			</div>
		</div>
		
</template>

<script>
	import {  getNewslist, getCategory, getLinelist, getPc,getbottomnav,getcampcomment,getuserdata,checktoken,regettoken,ratecomment,getTempKeys,commentdelete,checkUpload  } from '@/request/api'
	import COS from "cos-js-sdk-v5";
	let _this=null
	export default {
	  name: "Linelist",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  //搜索相关
				top_search_url:'/Siteall',
				options: [
				{
					value: '/Siteall',
					label: '全站搜索'
				},{
				  value: '/Camplist',
				  label: '营地搜索'
				}, {
				  value: '/Baselist',
				  label: '基地搜索'
				}, {
				  value: '/Courselist',
				  label: '课程搜索'
				},{
				  value: '/Newslist',
				  label: '资讯搜索'
				},
				{
				  value: '/Activitylist',
				  label: '活动搜索'
				},
				{
				  value: '/Linelist',
				  label: '线路搜索'
				},
				{
				  value: '/mentorlist',
				  label: '导师搜索'
				},],
				//搜索相关
				manage_url:'/',
				manageoptions:[
					{
					  value: '/',
					  label: '管理入口'
					}, {
					  value: 'https://yxwy.wanjiaxiao.cn/',
					  label: '机构管理后台'
					},
					 {
						value:'http://xh.wanjiaxiao.cn/seeyon/index.jsp',
						 label: '研学OA平台'
					 }
				],
				activeIndex2: '/Linelist',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				logintype:true,
				banner:[
				],
				camptypes:[
					{ text: '全部', value: 0 },
					// { text: '基地', value: 2 },
					// { text: '营地', value: 1 },
				],
				camptype:0,
				camplist:[],
				quicklist:[],
				aclist:[],
				newsiconon:'',
				category_id:'',
				total:0,
				page_index:1,
				uuid:'',
				linedata:{},
				pcsetdata:{},
				showQR:false,
				showserviceQR:false,
				showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
				activeName:'0',
				//评论相关
				commenttotal:0,
				comment_pageindex:1,
				replyrate:5,
				replytext:'',
				userdata:{},
				maxcount:9,
				fileList:[],
				//滑块验证码
				images: [
					require('../../../static/img/滑块1.jpg'),
					require('../../../static/img/滑块2.jpg'),
					require('../../../static/img/滑块3.jpg')
				],
				tipsMsg:'',
				isSuccess: true,
				showvisible:false,
				//评论滑块
				showreplyvisible:false,
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Newslist',
						text:'资讯资讯'
					},
					{
						link:'/Baselist',
						text:'基地列表'
					},
					{
						link:'/Courselist',
						text:'研学课程'
					},
					{
						link:'/Activitylist',
						text:'研学活动'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
					
					{
						link:'/mentorlist',
						text:'研学导师'
					},
					{
						link:'/expertlist',
						text:'专家团队'
					},
				],
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		  this.getpcset()
	  },
	  mounted() {
		   const { id } = this.$route.query;
		     window.addEventListener('resize', this.handleResize, true)
		   this.uuid = id
		   var token = localStorage.getItem('token')||''
		   if(token!=''){
			   this.getuserdata()
		   }
		   this.token=token
			this.getDetails()
			 this.getbottomnav()
			 
			 this.getcampcomment()
	  window.addEventListener('scroll', this.scrollToTop)
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
	  // 销毁监听
	  		beforeDestroy() {
	  		  window.removeEventListener('resize', this.handleResize);
	  		},
	  methods: {
		  gotopsearch(){
		  		  this.$router.push({
		  		    path: this.top_search_url,
		  		    name: this.top_search_url,
		  		    query: {
		  		      stitle: this.stitle,
		  		    }
		  		  }); 
		  },
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
		  gologin(){
		  			  this.$router.push({
		  			    path: "/Login",
		  			    name: "/Login",
		  				  query: {
		  				  }
		  			  });
		  },
		  //评论滑块
		  onreplySuccess(){
		  						  // this.isSuccess = true;
		  						  this.showreplyvisible=false
		  						  this.reply()
		  						  this.$refs.replyRef.reset();
		  },
		  onreplyFail(){
		  						  
		  },
		  onreplyRefresh(){
		  			  
		  },
		  onreplyAgain(){
		  			   this.$refs.replyRef.reset();
		  			   this.showreplyvisible=false
		  			  // this.loginshow=false
		  },
		  // 刷新成功后回调
		  onRefreshComplete(){
		  		  						  this.tipsMsg = ''
		  		  						  this.isSuccess = true;
		  },
		  getuserdata(){
		  		getuserdata().then(res=>{
		  			this.userdata=res.data.data
		  		})  
		  },
		  beforeAvatarUpload(file) {
		  		   var token = localStorage.getItem('token')||''
		  		   if(!token){
		  			this.gologin()
		  			 return false
		  		   }
		  		   console.log(file)
		  	// 设置图片格式 
		  	const imgArr = ["image/jpeg", "image/png", "image/jpg", "image/gif","video/mp4"];
		  	const isJPG = imgArr.includes(file.type);
		  	// const isLt2M = file.size / 1024 / 1024 < 2;
		  
		  	if (!isJPG) {
		  				this.$alert("上传图片只能是JPG格式、PNG格式或GIF格式,视频只能是MP4格式，且视频与图片只能传一种", '上传文件格式错误', {
		  					confirmButtonText: '确认',
		  					callback: action => {
		  						
		  					}
		  				});
		  			  return false
		  	}
		  			const imgtypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
		  			const vdotypes = ["video/mp4"];
		  			const isImg = imgtypes.includes(file.type)
		  			const isVdo = vdotypes.includes(file.type)
		  			if(isImg){
		  				this.houzhui='.jpg'
		  				this.acceptmedia='.jpeg, .png, .jpg, .gif'
		  				this.maxcount=9
		  			}
		  			if(this.acceptmedia=='.jpeg, .png, .jpg, .gif'){
		  				if(isVdo){
		  					this.$alert("视频与图片只能传一种，已传图片不能传视频", '视频与图片只能传一种', {
		  						confirmButtonText: '确认',
		  						callback: action => {
		  							
		  						}
		  					});
		  					return false
		  				}
		  			}
		  			if(isVdo){
		  				this.houzhui='.mp4'
		  				this.acceptmedia='.mp4'
		  				this.maxcount=1
		  			}
		  			if(this.acceptmedia=='.mp4'){
		  				if(isImg){
		  					this.$alert("视频与图片只能传一种，已传视频不能传图片", '视频与图片只能传一种', {
		  						confirmButtonText: '确认',
		  						callback: action => {
		  							
		  						}
		  					});
		  					return false
		  				}
		  			}
		  //     if (!isLt2M) {
		  //       this.$message.error("上传头像图片大小不能超过 2MB!");
		  			  // return
		  //     }
		  	
		    },
		    // 
		  upload(params) {
		  	console.log(params);
		  	// 上传到腾讯云服务器 SDK(语法)
		  		var fileList=this.fileList;
		  		  let timeStart = Date.now();
		  		  var imagename=this.uuid+this.userdata.unionId+'yanxuequan'+timeStart;
		  		  var cos = new COS({
		  			  getAuthorization: function (options, callback) {
		  				  // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
		  				  // 异步获取临时密钥
		  				  var data=options.Scope
		  				  console.log(options.Scope)
		  				  getTempKeys(data).then(res=>{
		  					  var data = res.data.data;
		  						console.log('data',data);
		  						var credentials = data && data.credentials;
		  						console.log('credentials',credentials);
		  					  if (!data || !credentials) return console.error('credentials invalid');
		  					  callback({
		  						  TmpSecretId: credentials.tmpSecretId,        // 临时密钥的 tmpSecretId
		  						  TmpSecretKey: credentials.tmpSecretKey,      // 临时密钥的 tmpSecretKey
		  						  SecurityToken: credentials.sessionToken, // 临时密钥的 sessionToken
		  						  // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
		  						  StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
		  						  ExpiredTime: data.expiredTime, // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
		  							ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
		  				});
		  			})
		  		}
		  	});
		  
		  	// const cos = new COS({
		  	//   SecretId: "AKIDB0ZtxlnfjXdU4N88dqmX3HCm56sEYAiz",
		  	//   SecretKey: "EXZJmyuEG3g8Yh02qyGKDqDSSTFxWvFJ",
		  	// });
		  	cos.putObject(
		  	  {
		  		Bucket: this.userdata.bucket /* 填入您自己的存储桶，必须字段 */,
		  		Region: this.userdata.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
		  		Key: '/handsign/group/'+imagename+this.houzhui /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
		  		Body: params.file /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */,
		  		onProgress: function (progressData) {
		  		  console.log(JSON.stringify(progressData));
		  		},
		  	  },
		  	  (err, data) => {
		  		console.log(err || data);
		  		if (data) {
		  		  // 通知父亲
		  				  console.log('data',data)
		  					fileList.push({ ...params.file, url:'http://'+data.Location,name:imagename+this.houzhui, });
		  					this.fileList=fileList
		  					console.log(this.fileList)
		  					data={
		  					  title:'/handsign/group/' +imagename+this.houzhui,
		  					}
		  					checkUpload(data).then(res=>{
		  						if(res.data.code==200){
		  							this.$message({
		  								message: '上传成功',
		  								type: 'success'
		  							});
		  						}else{
		  							this.$message({
		  								message: res.data.msg,
		  								type: 'warning'
		  							});
		  						}
		  					})
		  				  
		  		}
		  	  }
		  	);
		  },
		  handleExceed(files, fileList) {
		    this.$message.warning(`上传数量超出`);
		  },
		  beforeRemove(file, fileList) {
		  				console.log('shanchu',file, this.fileList,fileList)
		  				// return
		  				var that=this
		  				var cos = new COS({
		  					getAuthorization: function (options, callback) {
		  						// 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
		  						// 异步获取临时密钥
		  						  var data=options.Scope
		  						  console.log(options.Scope)
		  						getTempKeys(data).then(res=>{
		  							  var data = res.data.data;
		  								console.log('data',data);
		  								var credentials = data && data.credentials;
		  								console.log('credentials',credentials);
		  							  if (!data || !credentials) return console.error('credentials invalid');
		  							  callback({
		  								  TmpSecretId: credentials.tmpSecretId,        // 临时密钥的 tmpSecretId
		  								  TmpSecretKey: credentials.tmpSecretKey,      // 临时密钥的 tmpSecretKey
		  								  SecurityToken: credentials.sessionToken, // 临时密钥的 sessionToken
		  								  // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
		  								  StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
		  								  ExpiredTime: data.expiredTime, // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
		  									ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
		  							  });
		  						  })
		  					}
		  				});
		  				cos.deleteObject({
		  					Bucket: this.userdata.bucket /* 填入您自己的存储桶，必须字段 */,
		  					Region: this.userdata.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
		  					Key: '/handsign/group/' +file.name, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
		  				}, function(err, data) {
		  					console.log(err || data);
		  					if(fileList.length==0){
		  						that.maxcount=9
		  						that.acceptmedia='.jpeg, .png, .jpg, .gif, .mp4'
		  					}
		  					that.fileList=fileList
		  					console.log('删除成功')
		  				});
		  },
		    commentpagechange(val){
		    			this.comment_pageindex=val
		    			this.getcampcomment()
		    },
		    reply(){
		  	var token = localStorage.getItem('token')||''
		  	if(!token){
		  	  this.gologin()
		  	  return
		  	}
		  	var data={
		  	  
		  	}
		  	checktoken(data).then(res=>{
		  	  if(res.data.code==201){
		  		  console.log(res)
		  		  regettoken(data).then(res=>{
		  			  localStorage.setItem('token', res.data.data.token)
		  			  localStorage.setItem('refreshToken', res.data.data.refreshToken)
		  		  })
		  	  }
		  	  // if(res)
		  	})
		  	var imgs=[]
		  	var videos=''
		  	var list=this.fileList
		  	if(this.acceptmedia=='.jpeg, .png, .jpg, .gif'){
		  		for(var x=0;x<list.length;x++){
		  			imgs.push(list[x].url)
		  		}
		  	}else if(this.acceptmedia=='.mp4') {
		  		videos=list[0].url
		  	}
		  	data={
		  		type_id:this.uuid,
		  		type:4,
		  		content:this.replytext,
		  		imgs:imgs,
		  		videos:videos,
		  		star:this.replyrate,
		  	}
		  	if(!this.replytext){
		  	  this.$alert('请填写评论内容', '评论内容未填写', {
		  		confirmButtonText: '确认',
		  		callback: action => {
		  			
		  		}
		  	  });
		  	  return
		  	}
		  	ratecomment(data).then(res=>{
		  		if(res.data.code==200){
		  			this.$alert(res.data.data, '评论成功', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					this.replytext=''
		  					this.replyrate=5
		  					this.fileList=[]
		  					this.maxcount=9
		  					this.acceptmedia='.jpeg, .png, .jpg, .gif, .mp4'
		  					this.getcampcomment()
		  				}
		  			});
		  							 
		  		}
		  	})
		    					  
		    },
		  deletereply(id){
		  		  var that=this
		  			  var data ={
		  				id:id
		  			  }
		  			  this.$confirm('此操作将永久删除该评论, 是否继续?', '提示', {
		  				confirmButtonText: '确定',
		  				cancelButtonText: '取消',
		  				type: 'warning'
		  			  }).then(() => {
		  				commentdelete(data).then(res=>{
		  					this.$alert("评论删除成功", '删除成功', {
		  						confirmButtonText: '确认',
		  						callback: action => {
		  							that.comment_pageindex=1
		  							that.getcampcomment()
		  						}
		  					  });
		  				})
		  			  }).catch(() => {
		  				this.$message({
		  				  type: 'info',
		  				  message: '已取消删除'
		  				});          
		  			  });
		  },
		  getcampcomment(){
		  			var data={
		  			  type:4,
		  			  type_id:this.uuid,
		  			  page_index:this.comment_pageindex,
		  			  page_size:15,
		  			}  
		  			getcampcomment(data).then(res=>{
		  				this.commentlist=res.data.data.list
		  				this.commenttotal=res.data.data.total
		  			})
		  },
	  		  vanlinkgo(e){
	  		  		  console.log(e)
	  		  		  this.$router.push({
	  		  		    path: e.link,
	  		  		    name: e.link,
	  		  		    query: {
	  		  		    }
	  		  		  }); 
	  		  },
	  		  vannavmenushow(){
	  		  		this.vannavshow=false  
	  		  },
	  		  handleResize() {
	  		  		   this.top_bannerWidth = 0;
	  		    this.screenWidth = window.innerWidth;
	  		  		this.top_bannerWidth=window.innerWidth/3.42
	  		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	  		    this.screenHeight = window.innerHeight;
	  		  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15,
						flag:99
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
		  			  this.$router.push({
		  			    path: "/register",
		  			    name: "/register",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
	  		  getpcset(){
				var data={
				flag:99
			}
	  		  		getPc(data).then(res=>{
	  		  			this.pcsetdata=res.data.data
	  		  		})  
	  		  },
		  camptypetab(val){
			  this.camptype=val
			  this.getlist()
		  },
		  pagechange(val){
		  			  this.page_index=val
		  			   this.getlist()
		  },
		  getDetails(){
			var data={
				uuid: this.uuid,

			}  
			getLinelist(data).then(res=>{
				console.log(res.data)
				this.linedata=res.data.data
				const loading = this.$loading({
				         lock: true,
				         text: 'Loading',
				         spinner: 'el-icon-loading',
				         background: 'rgba(0, 0, 0, 0.7)'
				       });
				loading.close();
				// this.total=res.data.data.total
				// this.quicklist=res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getCategory(data).then(res=>{
			    			  console.log(res.data)
			    			  this.types=res.data.data
							  this.category_id=res.data.data[0].id
							  this._getNewslist()
			    }).catch(error => {
			    			  console.error(error);
			    			});
		  },
		  /*
		   * 查看详情
		   * */
		  golesson(e) {
		    this.$router.push({
		      path: "/CourseDetails",
		      name: "CourseDetails",
		      query: {
		        id: e
		      }
		    });
		  },
	  }
	};
</script>
<style>
	.el-descriptions__header{
		margin-bottom: 10px !important;
	}
	.el-descriptions-item{
		padding-bottom: 5px !important;
	}
	
</style>
<style scoped>
	::v-deep .el-tag--small{
		line-height: 24px;
	}
	.replys_item{
		
	}
	.replys_text{
		text-align: left;
		font-size: 15px;
		margin-bottom: 6px;
	}
	.replys_time{
		
	}
	.comment_icon{
		width: 40px;
		height: 40px;
		
	}
	.comment_icon img{
		width: 100%;
		height: 100%;
	}
	.commentmainbox{
		width: 280px;
		
	}
	.comment_rate{
		width: 130px;
		margin-bottom: 10px;
		
	}
	.commentmaintext{
		font-size: 16px;
		text-align: left;
		color:#303133;
		margin-bottom: 10px;
	}
	.comment_medium{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		margin-bottom: 10px;
	}
	.medium_imgs{
		width: 80px;
		height: 80px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	.medium_imgs img{
		width: 100%;
		height: 100%;
	}
	.medium_video{
		width: 100%;
		height: 160px;
	}
	.comment_msg{
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		margin-bottom: 10px;
		color:#909399 ;
	}
	
	.upload-demo{
		text-align: left !important;
		width: 250px;
	}
	.replybox{
		padding: 20px;
		    border-bottom: 1px solid #ececec;
	}
	.reply_rate{
		/* font-size: 32px; */
		display: flex;
		margin-bottom: 10px;
	}
	.reply_buttonbox{
		margin-top: 15px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.commentitem{
		padding: 20px;
		width: calc(100% - 40px);
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.replysbox{
		padding: 10px;
		background: #EBEEF5;
		border-radius: 5px;
		
	}
	.comment_more{
		padding: 10px;
	}
	
	.line_reply{
		    width: 395px;
		    background-color: #fff;
		    /* margin-top: 20px; */
		    /* border: 1px solid #dcdfe6; */
		    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
		
	}
	::v-deep .el-tabs__item.is-active{
		color: #FE7C2B;
		
		
	}
	::v-deep .el-tabs__item{
		font-size: 16px;
		font-weight: 600;
	}
	.el-tag--dark{
		border: 0px;
		margin:0px 2px;
	}
	.linemain{
		/* margin-top: 20px; */
		
	}
	.actmain_item{
		padding: 10px;
	}
	.line_mainbox{
		display: flex;
		width: 100%;
		justify-content: space-between;
		margin-top: 20px;
	}
	.line_tabsbox{
		width:780px;
		background-color: #fff;
	}
	.lessonbox{
		display: flex;
		align-items: center;
		padding-bottom:10px ;
		flex-wrap: wrap;
		background: #fff;
	}
	.lessontitle{
		width: calc(100% - 20px);
		padding:20px 10px;
		padding-top: 0px;
		font-size: 18px;
		font-weight: 600;
	}
	.lesson_item{
		width: 366px;
		margin-left: 10px;
		margin-bottom: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		background: #F2F6FC;
	}
	.lesson_item:hover{
		/* box-shadow: 0 3px 20px rgba(0,200,169,.8); */
		color: rgba(0,200,169,.8) !important;
	}
	.lessonimg{
		width: calc(100% -20px);
		height: auto;
		position: relative;
		aspect-ratio:375/210;
		padding: 10px;
		/* margin-right: 10px; */
	}
	.coures_item_type{
		position: absolute;
		display: flex;
		justify-content: flex-end;
		flex-wrap: wrap-reverse;
		right: 0;
		z-index: 11;
		bottom: 0;
		margin: 0 3px 3px 0;
	}
	.coures_item_type span{
		display: block;
		/* filter: alpha(opacity=90); */
		margin: 0 5px 5px 0;
		color: #fff;
		font-size: 12px;
		padding: 2px 10px;
	}
	.lessonimg img{
		width: 100%;
		height: 100%;
		aspect-ratio:375/210;
	}
	.lessonmsg_el{
		background: #F2F6FC;
	}
	::v-deep .lessonmsg_el>.el-descriptions__body{
		background: #F2F6FC;
	}
	.lessonmsg{
		width: calc(100% -40px);
		    padding: 20px;
		    padding-top: 0;
	}
	.lesson_title{
		    font-size: 22px;
			font-weight: 600;
		    min-height: 58px;
		    /* width: 100%; */
		    padding: 8px;
		   
		    text-align: left;
		    /* height: 19px; */
		    text-overflow: ellipsis;
		    white-space: normal;
		    overflow: hidden;
		    display: -webkit-box;
		    -webkit-line-clamp: 2;
	}
	.lesson_tag{
		 color: #333;
		/* width: 100%; */
		padding: 8px;
		text-align: left;
		display: flex;
		align-items: center;
	}
	
</style>